var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayoutRequest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1030_8832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6837 14.448C9.70901 14.5111 9.75301 14.5649 9.8098 14.6023C9.86658 14.6396 9.93344 14.6587 10.0014 14.657C10.0693 14.6552 10.1351 14.6328 10.1899 14.5925C10.2447 14.5523 10.2859 14.4963 10.308 14.432L14.6384 1.77376C14.6597 1.71473 14.6638 1.65084 14.6501 1.58958C14.6365 1.52832 14.6057 1.47222 14.5613 1.42784C14.5169 1.38346 14.4608 1.35264 14.3995 1.33898C14.3383 1.32532 14.2744 1.32938 14.2154 1.35071L1.55709 5.68117C1.49279 5.70322 1.43678 5.74441 1.39657 5.79921C1.35636 5.854 1.33388 5.91979 1.33214 5.98774C1.3304 6.05569 1.34949 6.12254 1.38684 6.17932C1.42419 6.23611 1.47802 6.28011 1.5411 6.30542L6.82426 8.42402C6.99127 8.49089 7.14302 8.59088 7.27034 8.71798C7.39767 8.84507 7.49793 8.99663 7.5651 9.16353L9.6837 14.448Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.56 1.43066L7.27148 8.7185",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1030_8832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutRequest);
export default __webpack_public_path__ + "static/media/payout_request.1f84b62b43c563f7375eab00465c738c.svg";
export { ForwardRef as ReactComponent };